import { render, staticRenderFns } from "./CustomerComplete.vue?vue&type=template&id=5a4b80a4&"
import script from "./CustomerComplete.vue?vue&type=script&lang=js&"
export * from "./CustomerComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports